import requestInstance from "./Request";
import { API_ENDPOINT } from "./Api";


let env = process.env.REACT_APP_B2B_API_BASE_URL;
// Update Trip API
export const updateTripApi = async (tripId, payload) => {
  try {
    const res = await requestInstance.patch(`${env}/trip-api/v3/edit-trips/${tripId}`, payload);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

export const getTripApi = async (tripId, payload) => {
  try {
    const res = await requestInstance.get(`${env}/trip-api/v1/trips/${tripId}`);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};

export const updateTripStatusApi = async (data) => {
  try {
    const res = await requestInstance.post(`${env}/trip-api/v3/trip-update-status`, data);
    return res?.data;
  } catch (err) {
    return err?.response;
  }
};
